<div class="right_section_header" id="devicePromoContent">
    <img class="header_icon promo-content-icon" alt="promo content" />
    <span i18n="@@device-popup-promo-content.title">PROMOTIONAL CONTENT</span>
</div>
<div class="mt-3" [ngClass]="isPromoEmpty ? 'existing_text_show': 'existing_text_hide'" id="promotionalContent"><span
        i18n="@@devices.side-menu.no-promo-content-msg">There is no
        Promotional Content in the Asset Library</span>
</div>
<iposcen-spinner-overlay></iposcen-spinner-overlay>
<div class="right_section_body" *ngIf="displayPromoContentGroups?.length >= 0" id="displayPromoContentGrp">
    <strong>{{displayPromoContentGroups.length}}
        <span i18n="@@device-popup-promo-content.promo-content-count.name">Promotional Content Groups</span>
    </strong>
    <div class="mt-4 mb-4" id="promoContentMsg">
        <div id="infoPromoContentMsg"><span i18n="@@device-popup-promo-content.info-promo-content-msg">Add Promotional Content to inform shoppers
                of everything from sales and rebates to tutorials or product demos.</span></div>
        <div id="infoPromoContentLimitMsg"><span i18n="@@device-popup-promo-content.promo-content-limit-msg">You can only <strong>select 3 Promotional
                    Content groups.</strong> </span>
        </div>
    </div>

    <!-- Content groups - Accordion -->
    <div class="accordion" id="devicesPromoConAcc">
        <!-- Group 1 -->
        <div class="card d-flex flex-row" id="devicesPromoConAccFlex">
            <div class="acc_check" id="accCheck">
                <div id="isDevicePromoName">
                    <input type="radio" name="cpLCGSelect" [value]="isDevicePromoNone" [checked]="isDevicePromoNone"
                        (change)="removeShowonDeveice()" />
                </div>
            </div>
            <div class="card-header-content" id="cardHeaderContent">
                <div class="title_left none_title_left" id="titleLeft">
                    <div class="d-flex" id="titleFlex">
                        <div class="title none_title" id="noneTitle">
                            <span i18n="@@device-price-content.title.none-label">None</span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="card"
            *ngFor="let promoContentGroup of displayPromoContentGroups | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize; index as i" id="cardPromo">
            <div class="card-header small_text" id="cardHeader">
                <div class="acc_check" id="accCheck">
                    <div class="form-check" id="frmCheck">
                        <input type="checkbox" class="form-check-input" [value]="promoContentGroup.selectedCG"
                            [checked]="isSelectedData.has(promoContentGroup.id)"
                            (change)="selectContentGroup($event,i,promoContentGroup)" name="devicePromoContent"
                            [disabled]="isSelectedData.size === 3 && !isSelectedData.has(promoContentGroup.id)" />
                    </div>
                </div>
                <div class="card-header-content" id="cardHeaderContent">
                    <div class="title_left" id="titleLeft">
                        <div class="title" id="title">
                            <span>{{promoContentGroup.configurations.publishedName}} &nbsp;&nbsp;</span>
                        </div>
                        <div *ngIf="(promoContentGroup.isContentExpires)" id="contentExpire" class="content-expire"><img class="contents-info-icon" alt="info_icon"><span>{{globConst.CONT_GRP_EXPIRED_TEXT}}</span></div>
                    </div>
                </div>
                <div id="promoContentGrpid" class="collapse_link collapsed collapse-button accordian-expanded-icon {{promoContentGroup?.id}}"
                    type="button" (click)="getDetailsOfPromoCG(promoContentGroup?.id)"
                    [ngClass]="promoContentGroup.isExpanded ? 'transform-180' : ''">
                </div>
            </div>
            <div id="collapseThree" class="collapse" #collapse="ngbCollapse"
                [(ngbCollapse)]="!promoContentGroup.isExpanded">
                <div class="card-body" id="cardBody">
                    <div class="table-container" id="tblContainer">
                        <table class="table-borderless" aria-describedby="Preview content">
                            <tr>
                                <th scope="col"><span i18n="@@promo-content.publish-date.time">Publishing Date and
                                        Time</span></th>
                                <th scope="col"><span i18n="@@promo-content.expire-date.time">Expiration Date and
                                        Time</span></th>
                            </tr>
                            <tr>
                                <td>{{promoContentGroup?.configurations?.publishTime | dateFormat: "24hrP"}}</td>
                                <td>{{promoContentGroup?. configurations?.expireTime | dateFormat: "24hrP"}}</td> 
                            </tr>
                        </table>
                    </div>
                    <div id="IdleExperiencePreviewSection" class="form-group idleExperiencePreviewSection" *ngIf="promoContentGroup?.configurations?.contentGroupPages?.length">
                        <form>
                            <div [ngClass]="{'width-Added-other-language': ['cs','pl'].includes(globConst.IPOS_LANGUAGE)}">
                                <input type="radio" name="ptPCGSelect" class="form-check-input" value=globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS
                                (change)="togglePreviewTabs(globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS, promoContentGroup?.id)" [checked]= "globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS ==  promoContentGroup.isIdleExperienceEnabled"/>
                                <label class="form-check-input" for="isIdleExperiencePreview">
                                    {{globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS}}
                                </label>
                            </div>
                            <div>
                                <input type="radio" name="ptPCGSelect" class="form-check-input" value=globConst.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE
                                [checked]= "globConst.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE ==  promoContentGroup.isIdleExperienceEnabled"
                                (change)="togglePreviewTabs(globConst.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE, promoContentGroup?.id)" />
                                <label class="form-check-input" for="isIdleExperiencePreview">
                                    {{globConst.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE}}
                                </label>
                            </div>
                        </form>
                    </div>
                    <div class="mini-preview-container" id="minPreviewCon">
                        <div class="d-flex container-overflow" id="previewFlex">
                            <ng-container *ngFor="let page of promoContentGroup.configurations.contentGroupPages">
                                <iposcen-mini-live-preview [data]="loadMiniPreview(promoContentGroup.id,page)"
                                [isIdleExperienceEnable]="promoContentGroup.isIdleExperienceEnabled"></iposcen-mini-live-preview>                                  
                            </ng-container>
                        </div>                        
                        <!-- {{promoContentGroup | json}} -->
                        <div id="contentGrpTble">
                            <table class="table-borderless form-factors-main-div" aria-describedby="Form factors">
                                <tr>
                                    <th scope="col"><span i18n="@@promo-content.content-group-applies-to">Content Group
                                            Applies
                                            To</span>:</th>
                                </tr>
                                <tr>
                                    <td><strong><span>{{deviceTypes}}</span>: </strong>
                                        {{ promoContentGroup?.configurations?.formFactor?.devices.length ?
                                        promoContentGroup?.configurations?.formFactor?.devices:globConst.ALL}}</td>
                                </tr>
                                <tr>
                                    <td><strong><span>{{manufacturers}}</span>: </strong>
                                        {{ promoContentGroup?.configurations?.formFactor?.manufacturer.length ?
                                        promoContentGroup?.configurations?.formFactor?.manufacturer :globConst.ALL}}
                                    </td>
                                </tr>
                                <tr>
                                    <td><strong><span>{{processors}}</span>:</strong>
                                        {{ promoContentGroup?.configurations?.formFactor?.processors.length ?
                                        promoContentGroup?.configurations?.formFactor?.processors :globConst.ALL}}
                                    </td>
                                </tr>
                                <tr>
                                    <td><strong><span>{{generation}}</span>: </strong>
                                        {{ promoContentGroup?.configurations?.formFactor?.generations.length ?
                                        promoContentGroup?.configurations?.formFactor?.generations :globConst.ALL}}
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Pagination -->
    <div class="d-flex flex-column align-items-center mt-auto" id="promoConPagination"           *ngIf="displayPromoContentGroups?.length > 0">
        <nav aria-label="promo content pagination">
            <ngb-pagination [collectionSize]="displayPromoContentGroups.length" [(page)]="page" [pageSize]="pageSize"
                [rotate]="true" [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false"></ngb-pagination>
        </nav>
        <div class="mt-1 text-center" id="selectedContGrpForProfile">{{this.selctedContGrpsForProfile.selectedCG.length}} <span
                i18n="@@device-popup-promo-content.selected-content-groups-number-text">Selected</span></div>
    </div>
</div>
<!-- CTA Buttons -->
<div class="button_wrapper justify-content-end" *ngIf="displayPromoContentGroups?.length >= 0" id="btnWrapper">
    <button type="button" class="btn btn-outline-primary btn-lg" [innerHTML]="cancelChanges" (click)='cancel()'
        [disabled]='!isDevicePromoNone && isSelectedData.size === 0'></button>
    <button type="button" [disabled]='!isDevicePromoNone && isSelectedData.size === 0' class="btn btn-primary btn-lg gtmEditDeviceSavePromoContent"
        [innerHTML]="saveChanges" (click)='sendDataToStore()'></button>
</div>

<div class="container" id="container">
    <div class="modal-dialog-centered" *ngIf="openModalPopup" id="modalDialog">
        <div class="modal-backdrop show" id="modalBackdrop"></div>
        <div class="modal" id="myModal">
            <div class="modal-dialog" id="myModalDialog">
                <div class="modal-content" id="myModalContain">
                    <div _ngcontent-fjy-c198="" class="close" (click)="closeModal()" id="closeModal"><img _ngcontent-fjy-c198=""
                            alt="close" class="modal-close-icon"></div>
                    <div class="modal-body" id="modalBody">
                        <div class="text-center" id="successMsg" *ngIf='!isCancel'>
                            <span class="success-img"></span>
                        </div>
                        <div class="action-success-msg" id="actionSuccessMsg" [ngClass]="isCancel ? 'text-left': 'text-center'">
                            <span>{{successMessage}}</span>
                        </div>
                        <div class="card_desc" id="cardDesc">
                            <span>{{description}}</span>
                        </div>
                    </div>
                    <div *ngIf='isCancel' class='modal-footer' id="cardFooter">
                        <button class='btn btn-outline-primary btn-lg' (click)="closeModal()">{{buttonLabelNo}}</button>
                        <button class='btn btn-primary btn-lg' (click)='dismiss()'>{{buttonLabelCancel}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>